import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import { App } from '@capacitor/app'
import { Capacitor } from '@capacitor/core'
import { syncDeviceNotificationStateToFirestore } from '@/lib/notifications'
import { useAuthState } from '@/hooks/useAuth'
import { AppSettings } from '@/components/shared/AppSettings'

export default function SettingsPage() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { user } = useAuthState()

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return
    const platform = Capacitor.getPlatform()
    if (platform !== 'ios' && platform !== 'android') return
    if (!user?.uid) return

    // Listen for when the app comes back into focus
    // This allows us to detect if the user changed notification settings in iOS Settings
    const handleAppResume = async () => {
      console.log('[SettingsPage] App resumed, syncing notification state...')
      await syncDeviceNotificationStateToFirestore(user.uid)
    }

    let appListener: any

    const setupListener = async () => {
      appListener = await App.addListener('appStateChange', async (state) => {
        if (state.isActive) {
          await handleAppResume()
        }
      })
    }

    setupListener()

    return () => {
      appListener?.remove()
    }
  }, [user?.uid])

  return (
    <div className="flex h-screen-mobile-minus-nav min-h-0 flex-col gap-3 bg-background transition-colors">
      {/* Title row: same pattern as ChatsPage (top-left, full width) */}
      <div className="flex w-full shrink-0 items-start justify-between gap-2 phone-container-padded pt-safe-native-top-cushion md:pt-4">
        <div className="flex min-w-0 flex-1 flex-col">
          <h1 className="text-page-title text-foreground">{t('settings.title')}</h1>
        </div>
      </div>

      <div className="flex min-h-0 min-w-0 w-full flex-1 flex-col overflow-y-auto pb-bottom-nav phone-container-padded [-webkit-overflow-scrolling:touch]">
        <AppSettings showLogout onLogoutSuccess={() => navigate('/')} />
      </div>
    </div>
  )
}

